import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'

import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-page-not-found',
  templateUrl: './bmcore-page-not-found.component.html',
  styleUrls: ['./bmcore-page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePageNotFoundComponent implements OnInit {
  @Input() colorSettingsMode = false
  @Input() pageIsNotAvailable = false

  lg: LgType

  constructor(
    private i18nService: I18nService,
    private titleService: Title
  ) {
    titleService.setTitle('Page Not Found | beatmakers.tv')
  }

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
  }
}
